










































































































































































































































import Vue from 'vue';
import router from '@/router/index';

export default Vue.extend({
    //components: { About },
    name: 'CreateEvent',
    data() {
        return {
            fileUploadList:[{}],
            fileUpload: null,
            input_addNewEventOrganizer:"",
            input_addNewEventType:"",
            event_date_selection: "",
            event_startDate_model: "",
            event_endDate_model: "",
            event_startTime:"",
            event_endTime:"",
            eventDateSelectionInputColor: "#1abc9c",
            eventStartDateSelectionInputColor: "#1abc9c",
            eventEndDateSelectionInputColor: "#1abc9c",
            startTimeInputColor: "#1abc9c",
            endTimeInputColor: "#1abc9c",
            eventNameInputColor: "#1abc9c",
            eventOwnerNameInputColor: "#1abc9c",
            eventVenueInputColor: "#1abc9c",
            startDateTimeInputColor: "#1abc9c",
            endDateTimeInputColor: "#1abc9c",
            speakerInputColor: "#1abc9c",
            eventTypeInputColor: "#1abc9c",
            eventOrganizerInputColor: "#1abc9c",
            numParticipantsInputColor: "#1abc9c",
            eventParticipantsInputColor: "#1abc9c",
            eventRemarksInputColor: "#1abc9c",
            eventGrantsInputColor: "#1abc9c",
            //orgOptionList:[],
            orgOptionList:[{eventOrganizerId:-1,eventorg:""}],
            //eventTypeOptionList:[],
            eventTypeOptionList:[{eventTypeId:-1,eventType:""}],
            isUpdateEvent:false,
            event_type: 0,
            event_organizer: 0,
            org_rc: 0,
            event_name: "",
            event_owner_name: "",
            event_venue: "",
            event_facilatators_presenters_speakers: "",
            num_participants: 0,
            attendance_list: "",
            event_start_datetime: "",
            event_end_datetime: "",
            event_date:"",
            event_end_date:"",
            event_duration: "",
            event_remarks: "",
            event_research_grant: "",
            venue_placeholder:"Venue",
            event_online: false,
            event_allday: false,
            view_mode: false,
            isEventTypeWouUpskill: false,
        }
    },
    mounted(){
        this.updateOrganizerList();
        this.updateEventTypeList();
        this.fileUploadList = [];
    },
    methods: {
        handler_onlineEventInputChange: function(){
            if(this.event_online){
                this.event_venue=""
                this.venue_placeholder="N/A"
            }
            else{
                this.venue_placeholder="Venue"
            }
        },
        handler_allDayInputChange: function(){
            if(this.event_allday){
                this.event_startTime = "00:00";
                this.event_endTime = "23:59";
                this.event_endDate_model = this.event_startDate_model;
            }
        },
        handler_eventTypeChange : function(){
            //console.log("this.event_type")
            //console.log(this.event_type)
            //console.log(this.eventTypeOptionList)

            var temp_eventTypeName = ""
            for(var i = 0; i < this.eventTypeOptionList.length; i++){
                if(this.eventTypeOptionList[i].eventTypeId==this.event_type){
                    temp_eventTypeName = this.eventTypeOptionList[i].eventType
                }
            }
            console.log(temp_eventTypeName)

            if(temp_eventTypeName.includes('Upskill with WOU') ){
                this.isEventTypeWouUpskill = true;
            }
            else{
                this.isEventTypeWouUpskill = false;
            }
            
        },
        countWords: function(){ 
            var var_wordCount = this.event_remarks.split(' ').length;
            //console.log("var_wordCount")
            //console.log(var_wordCount)
        },
        handler_selectFileAttachment: function(){
            if(this.$refs.file)
                (this.$refs.file as any).click();
        },
        changedUploadFile: function(e:any) {
            this.fileUpload = e.currentTarget.files[0]; 
            var filesize = (this.fileUpload as any).size
            //console.log("Filesize");
            //console.log(filesize);
            if ( filesize <= 10485760){ // 10mb limit
                var tempId = this.fileUploadList.length;  
                this.fileUploadList.push({id:tempId,filedata:this.fileUpload,filename:e.currentTarget.files[0].name});
                //console.log("File Added")
                //console.log(this.fileUploadList)
            }
            else{
                alert("File attachment size cannot be above 10MB");
            }
        },
        uploadFile: function(eventId:string) {    
            if(this.fileUploadList.length > 0){
                for(var x = 0; x < this.fileUploadList.length; x++){
                    let formData = new FormData();
                    formData.append('eventId', `${eventId}`);
                    formData.append('img', (this.fileUploadList[x] as any).filedata);

                    fetch( `${this.$server_address}/FileUpload`, {
                        method: 'POST',
                        credentials: 'include',
                        body: formData
                    } )
                    .then(
                        function(res){ 
                            if (res.status === 401) {
                                router.push({ name: 'Login'});
                                throw new Error('Unauthorize');
                            }
                            if (res.status === 200) {
                                return res.json();
                            } 
                        }
                    )
                    .then(
                        (data) => {
                           console.log(data);
                        } 
                    )
                    .catch((err)=>console.error(err))
                }
            }
            /*
            if(this.fileUpload){               
                let formData = new FormData();
                console.log(this.fileUpload);
                console.log("happen")
                console.log(`${eventId}`)

                formData.append('eventId', `${eventId}`);
                formData.append('img', (this.fileUpload as any));
                console.log(formData);
                
                for (var pair of formData.entries()) {
                    console.log(pair[0]+ ', ' + pair[1]); 
                }

                fetch( `${this.$server_address}/FileUpload`, {
                    method: 'POST',
                    credentials: 'include',
                    body: formData
                } )
            }
            */
        },
        handler_addEventOrganizerBtnAdd: function(){
             fetch(`${this.$server_address}/AddNewEventOrganizer`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Accept': 'application/json; charset=utf-8',
                    'Content-Type': 'application/json',
                },
                body:JSON.stringify({eventOrganizerName:this.input_addNewEventOrganizer})
            }).then(
                function(res){ 
                    if (res.status === 401) {
                        router.push({ name: 'Login'});
                        throw new Error('Unauthorize');
                    }
                    if (res.status === 200) {
                        return res.json();
                    } 
                }
            )
            .then(
                (data) => {
                    this.updateOrganizerList();
                    this.updateEventTypeList();
                    alert("Added Event Organizer");
                } 
            )
            .catch(
                (err)=>{
                    console.error(err)
                }
            )
            this.$modal.hide('modalAddEventOrganizerName');
        },
        handler_addEventOrganizerBtnBack: function(){
            this.$modal.hide('modalAddEventOrganizerName');
        },
        handler_addNewEventOrganizerField:function(){
            this.$modal.show('modalAddEventOrganizerName');
        },


        handler_addEventTypeBtnAdd: function(){
             fetch(`${this.$server_address}/AddNewEventType`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Accept': 'application/json; charset=utf-8',
                    'Content-Type': 'application/json',
                },
                body:JSON.stringify({eventTypeName:this.input_addNewEventType})
            }).then(
                function(res){ 
                    if (res.status === 401) {
                        router.push({ name: 'Login'});
                        throw new Error('Unauthorize');
                    }
                    if (res.status === 200) {
                        return res.json();
                    } 
                }
            )
            .then(
                (data) => {
                    this.updateOrganizerList();
                    this.updateEventTypeList();
                    alert("Added Event Type");
                } 
            )
            .catch(
                (err)=>{
                    console.error(err)
                }
            )
            this.$modal.hide('modalAddEventTypeName');
        },
        handler_showEventTypeDefinitions: function(){
            this.$modal.show('modalEventTypeDefinitionsName');
        },
        handler_addEventTypeBtnBack: function(){
            this.$modal.hide('modalAddEventTypeName');
        },
        handler_addNewEventTypeField:function(){
            this.$modal.show('modalAddEventTypeName');
        },
        updateEventTypeList: function(){
            this.eventTypeOptionList = [];
            fetch(`${this.$server_address}/GetAllEventTypes`, {
                method: 'GET',
                credentials: 'include',
                //body:JSON.stringify({title:"a new todo"})
            }).then(
                 function(res){ 
                    if (res.status === 401) {
                        router.push({ name: 'Login'});
                        throw new Error('Unauthorize');
                    }
                    if (res.status === 200) {
                        return res.json();
                    } 
                }
            )
            .then(
                (data) => {
                    this.eventTypeOptionList = data;
                } 
            )
            .catch((err)=>console.error(err))
        },
        updateOrganizerList: function(){
            this.orgOptionList = [];
            fetch(`${this.$server_address}/GetAllEventOrganizers`, {
                method: 'GET',
                credentials: 'include',
                //body:JSON.stringify({title:"a new todo"})
            }).then(
                 function(res){ 
                    if (res.status === 401) {
                        router.push({ name: 'Login'});
                        throw new Error('Unauthorize');
                    }
                    if (res.status === 200) {
                        return res.json();
                    } 
                }
            )
            .then(
                (data) => {
                    this.orgOptionList = data;
                } 
            )
            .catch((err)=>console.error(err))
        },
        eventDetailReader: function(idEventToRead:number){
            //console.log("Reader");
            //console.log(idEventToRead);

            if(idEventToRead < 0 || idEventToRead == undefined){ //-1 NewEvent
                return;
            } 

            fetch(`${this.$server_address}/GetSingleEventDetails`,
            {
                method: "POST",
                credentials: 'include',
                headers: {
                    'Accept': 'application/json; charset=utf-8',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify( {"eventId":idEventToRead} )
            })
            .then(
                 function(res){ 
                    if (res.status === 401) {
                        router.push({ name: 'Login'});
                        throw new Error('Unauthorize');
                    }
                    if (res.status === 200) {
                        return res.json();
                    } 
                }
            )
            .then(
                (data) => {
                    if(data.length > 0){
                        this.event_name = data[0].eventName;
                        this.num_participants = data[0].numberParticipants;

                        if(data[0].eventOrgId)
                            this.event_organizer = data[0].eventOrgId;
                        else
                            this.event_organizer = 0;

                        if(data[0].eventTypeId)
                            this.event_type = data[0].eventTypeId;
                        else
                            this.event_type = 0;

                        //eg. 2021-11-21T10:35:46.241644
                        if(data[0].eventStartTime){
                            //var startDateTemp:string = data[0].eventstarttime.split("T");
                            //var startdatetime = new Date('2021-11-21T14:35:46.241644');
                            //var startdatetime = new Date(data[0].eventstarttime);
                            //var year = startdatetime.getFullYear();
                            //var month = startdatetime.getMonth()+1;
                            //var day = startdatetime.getDate();
                            //var hour = startdatetime.getHours();
                            //var minutes = startdatetime.getUTCMinutes();
                            //var dateFormat = `${year}-${month}-${day}T${hour}:${minutes}`;
                            //console.log(this.event_start_datetime); 
                            this.event_start_datetime = data[0].eventStartTime; 
                        }  
                        else{
                            this.event_start_datetime = "";
                        }

                        this.event_remarks = data[0].remarks;

                        if(data[0].eventEndTime){
                            this.event_end_datetime = data[0].eventEndTime; 
                        }
                        else{
                            this.event_end_datetime  = "";
                        }
                    }
                    else{
                        console.log("ERROR")
                        this.event_name = "";
                        this.num_participants = 0;
                        this.event_organizer = 0;
                        this.event_type = 0;
                        this.event_start_datetime = "";
                        this.event_end_datetime  = "";
                    }
                  

                } 
            )
            .catch((err)=>console.error(err))

            fetch(`${this.$server_address}/GetNameOfPresenterFacilitators`,
            {
                method: "POST",
                credentials: 'include',
                headers: {
                    'Accept': 'application/json; charset=utf-8',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify( {"eventId":idEventToRead} )
            })
            .then(
                 function(res){ 
                    if (res.status === 401) {
                        router.push({ name: 'Login'});
                        throw new Error('Unauthorize');
                    }
                    if (res.status === 200) {
                        return res.json();
                    } 
                }
            )
            .then(
                (data) => {
                    if(data.length > 0){
                        this.event_facilatators_presenters_speakers = data[0].nameFacilitatorsPresentersSpeakers;
                    }
                    else{
                        this.event_facilatators_presenters_speakers = "";
                    }
                    
                } 
            )
            .catch((err)=>console.error(err))

            fetch(`${this.$server_address}/GetAttendanceList`,
            {
                method: "POST",
                credentials: 'include',
                headers: {
                    'Accept': 'application/json; charset=utf-8',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify( {"eventId":idEventToRead} )
            })
            .then(
                 function(res){ 
                    if (res.status === 401) {
                        router.push({ name: 'Login'});
                        throw new Error('Unauthorize');
                    }
                    if (res.status === 200) {
                        return res.json();
                    } 
                }
            )
            .then(
                (data) => {
                    //console.log("data22");
                    //console.log(data);

                    if(data.length > 0){
                        this.attendance_list = data[0].attendancelist;
                    }
                    else{
                        this.attendance_list = "";
                    }
                } 
            )
            .catch((err)=>console.error(err))

            /*
            fetch(`${this.$server_address}/GetRemarks`,
            {
                method: "POST",
                credentials: 'include',
                headers: {
                    'Accept': 'application/json; charset=utf-8',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify( {"eventId":idEventToRead} )
            })
            .then(
                 function(res){ 
                    if (res.status === 401) {
                        router.push({ name: 'Login'});
                        throw new Error('Unauthorize');
                    }
                    if (res.status === 200) {
                        return res.json();
                    } 
                }
            )
            .then(
                (data) => {
                    //console.log("data33");
                    //console.log(data);

                    if(data.length > 0){
                        this.event_remarks = data[0].remarks;
                    }
                    else{
                        this.event_remarks = "";
                    }
                    
                } 
            )
            */
            //.catch((err)=>console.error(err))

            //var startDateTemp:string =  this.$store.state.event_list[idEventToRead].event_date.split("T");
            //var endDateTemp:string =  this.$store.state.event_list[idEventToRead].event_end_date.split("T");

            //this.event_type = this.$store.state.event_list[idEventToRead].event_type
            //this.event_organizer = this.$store.state.event_list[idEventToRead].event_org
            //this.org_rc = this.$store.state.event_list[idEventToRead].rc_loc
            //this.event_name = this.$store.state.event_list[idEventToRead].event_name
            //this.event_facilatators_presenters_speakers = this.$store.state.event_list[idEventToRead].name_facilitators_presenters_speakers
            //this.num_participants = this.$store.state.event_list[idEventToRead].number_participants
            //this.attendance_list = this.$store.state.event_list[idEventToRead].attendance_list
            //this.event_date = startDateTemp[0];
            //this.event_end_date = endDateTemp[0];
            //this.event_duration = this.$store.state.event_list[idEventToRead].duration
            //this.event_remarks = this.$store.state.event_list[idEventToRead].remarks
        },
        handler_backButton: function(){
            //window.location.href = `http://localhost:8080/#/allEvents`;
            router.push({ name: 'allEvents'});
        },
        addNewEventButtonHandler: function() {
            if(!this.$store.state.user_login.username){
                return;
            }

            if(this.$store.state.user_login.username == ""){
                return;
            }

            console.log(`this.event_type = ${this.event_type}`);
            console.log(`this.event_organizer = ${this.event_organizer}`);
            //console.log(`this.org_rc = ${this.org_rc}`);
            console.log(`this.event_name = ${this.event_name}`);
            console.log(`this.event_facilatators_presenters_speakers = ${this.event_facilatators_presenters_speakers}`);
            console.log(`this.num_participants = ${this.num_participants}`);
            console.log(`this.attendance_list = ${this.attendance_list}`);
            console.log(`this.event_startDate_model = ${this.event_startDate_model}`);
            console.log(`this.event_startTime = ${this.event_startTime}`);
            console.log(`this.event_endTime = ${this.event_endTime}`);
            //console.log(`this.event_end_date = ${this.event_end_date}`);
            
            //console.log(`this.event_duration = ${this.event_duration}`);
            console.log(`this.event_remarks = ${this.event_remarks}`);
            console.log(`this.createdBy = ${this.$store.state.user_login.username}`);

            var issue_msg = "";
            if(!this.event_name || this.event_name == ''){
                issue_msg += "Please enter the event name\n";
                this.eventNameInputColor = "#d50d0d";
            }else{
                this.eventNameInputColor = "#1abc9c";
            }

            if(!this.event_owner_name || this.event_owner_name == ''){
                issue_msg += "Please enter the event owner\n";
                this.eventOwnerNameInputColor = "#d50d0d";
            }else{
                this.eventOwnerNameInputColor = "#1abc9c";
            }

            if(!this.event_type || this.event_type == 0){
                issue_msg += "Please select an Event Type\n";
                this.eventTypeInputColor = "#d50d0d";
            }else{
                this.eventTypeInputColor = "#1abc9c";
            }

            if(!this.event_organizer || this.event_organizer == 0){
                issue_msg += "Please select an Organizer\n";
                this.eventOrganizerInputColor = "#d50d0d";
            }else{
                this.eventOrganizerInputColor = "#1abc9c";
            }

            if(!this.event_facilatators_presenters_speakers || this.event_facilatators_presenters_speakers == ''){
                issue_msg += "Please enter the Facilatators/Presenters/Speakers name\n";
                this.speakerInputColor = "#d50d0d";
            }else{
                this.speakerInputColor = "#1abc9c";
            }

            if(!this.num_participants || this.num_participants <= 0){
                issue_msg += "Please enter a valid number of participants\n";
                this.numParticipantsInputColor = "#d50d0d";
            }else{
                this.numParticipantsInputColor = "#1abc9c";
            }

            if(this.event_startDate_model == ""){
                issue_msg += "Please select the event start date\n";
                this.eventStartDateSelectionInputColor = "#d50d0d";
            }else{
                this.eventStartDateSelectionInputColor = "#1abc9c";
            }

            if(this.event_endDate_model == ""){
                issue_msg += "Please select the event end date\n";
                this.eventEndDateSelectionInputColor = "#d50d0d";
            }else{
                this.eventEndDateSelectionInputColor = "#1abc9c";
            }

            if(this.event_startTime == ""){
                issue_msg += "Please select event start time\n";
                this.startTimeInputColor = "#d50d0d";
            }else{
                this.startTimeInputColor = "#1abc9c";
            }

            if(this.event_startTime == ""){
                issue_msg += "Please select event end time\n";
                this.endTimeInputColor = "#d50d0d";
            }else{
                this.endTimeInputColor = "#1abc9c";
            }

            if(!this.event_remarks || this.event_remarks == ''){
                issue_msg += "Please enter a brief description of the event\n";
                this.eventRemarksInputColor  = "#d50d0d";
            }else{
                 var remark_wordCount = this.event_remarks.split(' ').length;
            if(remark_wordCount > 200){
                issue_msg += "Brief description cannot be above 200 words\n";
                    this.eventRemarksInputColor  = "#d50d0d";
                }
                else{
                    this.eventRemarksInputColor = "#1abc9c";
                }
            }

            if(this.isEventTypeWouUpskill && this.event_research_grant == ''){
                issue_msg += "Please enter involve research grants\n";
                this.eventGrantsInputColor = "#d50d0d";
            }
            else{
                this.eventGrantsInputColor = "#1abc9c";
            }

            this.event_start_datetime = `${this.event_startDate_model}T${this.event_startTime}`;
            this.event_end_datetime = `${this.event_endDate_model}T${this.event_endTime}`;

            //console.log(`this.event_start_datetime = ${this.event_start_datetime}`);
            //console.log(`this.event_end_datetime = ${this.event_end_datetime}`);

            //if(!this.event_start_datetime || this.event_start_datetime == ''){
            //    issue_msg += "Please select the start date and time\n";
            //    this.startDateTimeInputColor = "#d50d0d";
            //}else{
            //    this.startDateTimeInputColor = "#1abc9c";
            //}

            //if(!this.event_end_datetime || this.event_end_datetime == ''){
            //    issue_msg += "Please select the start date and time\n";
            //    this.endDateTimeInputColor = "#d50d0d";
            //}else{
            //    this.endDateTimeInputColor = "#1abc9c";
            //}

            var startDatetimeCheck = new Date(this.event_start_datetime);
            var endDatetimeCheck = new Date(this.event_end_datetime);

            if(startDatetimeCheck>endDatetimeCheck){
                issue_msg += "Start datetime cannot be higher than End datetime\n";
                this.eventStartDateSelectionInputColor = "#d50d0d";
                this.eventEndDateSelectionInputColor = "#d50d0d";
                this.startDateTimeInputColor = "#d50d0d";
                this.endDateTimeInputColor = "#d50d0d";
            }

            if(issue_msg != ''){
                alert(`Issues detected:\n${issue_msg}`);
                this.$parent.$el.scrollTo(0,0);
                return;
            }

            var temp_send_event_grant = ""
            if(this.isEventTypeWouUpskill){
                temp_send_event_grant = this.event_research_grant;
            }

            // Workaround for "boolean type" fetch post  pass to dotnet always return false
            var temp_allDay_send = "false"
            if(this.event_allday){
                temp_allDay_send = "true"
            }

            // Workaround for "boolean type" fetch post pass to dotnet always return false
            var temp_onlineEvent_send = "false"
            if(this.event_online){
                temp_onlineEvent_send = "true"
            }

            var dataSend = {
                "eventType": this.event_type,
                "eventOwner": this.event_owner_name,
                "eventOrganizer":this.event_organizer,
                //"orgRc": this.org_rc,
                "eventName": this.event_name,
                "eventFacilatatorsPresentersSpeakers": this.event_facilatators_presenters_speakers,
                "numParticipants": this.num_participants,
                "attendanceList": this.attendance_list,
                //"eventStartDate": this.event_date,
                "allDay": temp_allDay_send,
                "eventStartDatetime": this.event_start_datetime,
                "eventEndDatetime": this.event_end_datetime,
                //"eventEndDate": this.event_end_date,
                //"eventDuration": this.event_duration,
                "eventRemarks": this.event_remarks,
                "eventGrants": temp_send_event_grant,
                "onlineEvent": temp_onlineEvent_send,
                "eventVenue": this.event_venue,
                "createdBy": this.$store.state.user_login.username
            }

            fetch(`${this.$server_address}/AddNewEvent`,
            {
                method: "POST",
                credentials: 'include',
                headers: {
                    'Accept': 'application/json; charset=utf-8',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify( dataSend )
            })
            .then(
                 function(res){ 
                    if (res.status === 401) {
                        router.push({ name: 'Login'});
                        throw new Error('Unauthorize');
                    }
                    if (res.status === 200) {
                        return res.json();
                    } 
                }
            )
            .then((data) => {
                if(data.errorCode==0){
                    this.uploadFile(`${data.newEventId}`);
                    alert("Event Successfully added");
                    //window.location.href = `http://localhost:8080/#/`;
                    //router.push({name: 'Home'});
                    this.$emit('close');
                }
                else{
                    alert(data.errorMsg);
                }
             })
             .catch((err)=>console.error(err))
            
        },
    },
       watch: {
        /*
        event_type: function() {
            console.log("event_type have changes");
            console.log(this.event_type);
        },
        event_organizer: function() {
            console.log("event_organizer have changes");
            console.log(this.event_organizer);
        },
        org_rc: function() {
            console.log("org_rc have changes");
            console.log(this.org_rc);
        },
        event_name: function() {
            console.log("event_name have changes");
            console.log(this.event_name);
        },
        event_facilatators_presenters_speakers: function() {
            console.log("event_facilatators_presenters_speakers have changes");
            console.log(this.event_facilatators_presenters_speakers);
        },
        num_participants: function() {
            console.log("num_participants have changes");
            console.log(this.num_participants);
        },
        attendance_list: function() {
            console.log("attendance_list have changes");
            console.log(this.attendance_list);
        },
        event_start_date: function() {
            console.log("event_date have changes");
            console.log(this.event_date);
        },
        event_end_date: function() {
            console.log("event_end_date have changes");
            console.log(this.event_end_date);
        },
        event_duration: function() {
            console.log("event_duration have changes");
            console.log(this.event_duration);
        },
        event_remarks: function() {
            console.log("event_remarks have changes");
            console.log(this.event_remarks);
        },
        */
    },
    computed: {
        /*
        event_type: {
            get() {
                return this.$store.state.event_list;
            },
            set(value) {
                console.log("Changing event_type value");
                console.log(value);
                //this.$store.commit('updateFirstName', value);
            },
        },  
        event_organizer: {
            get() {
                return this.$store.state.event_list;
            },
            set(value) {
                console.log("Changing event_organizer value");
                console.log(value);
                //this.$store.commit('updateFirstName', value);
            },
        },
        org_rc: {
            get() {
                return this.$store.state.event_list;
            },
            set(value) {
                console.log("Changing org_rc value");
                console.log(value);
                //this.$store.commit('updateFirstName', value);
            },
        },
        event_name:{
            get() {
                return this.$store.state.event_list;
            },
            set(value) {
                console.log("Changing event_name value");
                console.log(value);
                //this.$store.commit('updateFirstName', value);
            },
        },
        event_facilatators_presenters_speakers:{
            get() {
                return this.$store.state.event_list;
            },
            set(value) {
                console.log("Changing event_facilatators_presenters_speakers value");
                console.log(value);
                //this.$store.commit('updateFirstName', value);
            },
        },
        num_participants:{
            get() {
                return this.$store.state.event_list;
            },
            set(value) {
                console.log("Changing num_participants value");
                console.log(value);
                //this.$store.commit('updateFirstName', value);
            },
        },
        */
    },
});
